import React from "react";

function GetMoreBooks() {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <button className="btn">See More</button>
    </div>
  );
}

export default GetMoreBooks;
